import { SeverityCounts } from '@totem/components/software/vulnerabilityReport/summary/types';

// Severity is an ordered scale: one hue, light (low) to dark (critical) on a light background and the reverse on a
// dark one. Validated for step separation and contrast against both surfaces; every use also carries a text label.
const SEVERITY_LIGHT: Record<keyof SeverityCounts, string> = {
  critical: '#7f1d1d',
  high: '#c03a2b',
  medium: '#e0694d',
  low: '#eb9a83',
  none: '#9ca3af',
};

const SEVERITY_DARK: Record<keyof SeverityCounts, string> = {
  critical: '#e9917c',
  high: '#d0614a',
  medium: '#b44a38',
  low: '#8e3027',
  none: '#6b7280',
};

// Trend series use the first three categorical slots, which validate as a set in both modes.
const TREND_LIGHT = ['#2a78d6', '#eb6834', '#1baf7a'];
const TREND_DARK = ['#3987e5', '#d95926', '#199e70'];

const SEQUENTIAL_LIGHT = '#2a78d6';
const SEQUENTIAL_DARK = '#3987e5';

export const SEVERITY_KEYS: (keyof SeverityCounts)[] = [
  'critical',
  'high',
  'medium',
  'low',
  'none',
];

export const SEVERITY_LABELS: Record<keyof SeverityCounts, string> = {
  critical: 'Critical',
  high: 'High',
  medium: 'Medium',
  low: 'Low',
  none: 'Not scored',
};

export const severityColors = (isDark: boolean) =>
  isDark ? SEVERITY_DARK : SEVERITY_LIGHT;

export const trendColors = (isDark: boolean) =>
  isDark ? TREND_DARK : TREND_LIGHT;

export const sequentialColor = (isDark: boolean) =>
  isDark ? SEQUENTIAL_DARK : SEQUENTIAL_LIGHT;

// True when the antd container background is dark.
export const isDarkBackground = (color: string) => {
  const hex = color.replace('#', '');
  if (hex.length < 6) {
    return false;
  }
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);
  return (red * 299 + green * 587 + blue * 114) / 1000 < 128;
};
